const InputField = ({ inputProps, changeValue }) => {
  const { label, type, inputMode, readOnly, placeholder, value } = inputProps;

  return (
    <div className="form-control">
      <label>{label}</label>
      <input
        type={type}
        inputMode={inputMode}
        readOnly={readOnly}
        placeholder={placeholder}
        value={value}
        onChange={(e) => changeValue(e.target.value)}
      />
    </div>
  );
};

export default InputField;
